var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1562 14.8438H1.09375C0.713477 14.8438 0.40625 14.5365 0.40625 14.1562V1.09375C0.40625 0.713476 0.713477 0.40625 1.09375 0.40625H14.1562C14.5365 0.40625 14.8438 0.713476 14.8438 1.09375V14.1562C14.8438 14.5365 14.5365 14.8438 14.1562 14.8438ZM13.2969 1.95312H1.95312V13.2969H13.2969V1.95312ZM16.9062 17.5938H3.67188C3.57734 17.5938 3.5 17.5164 3.5 17.4219V16.2188C3.5 16.1242 3.57734 16.0469 3.67188 16.0469H16.0469V3.67188C16.0469 3.57734 16.1242 3.5 16.2188 3.5H17.4219C17.5164 3.5 17.5938 3.57734 17.5938 3.67188V16.9062C17.5938 17.2865 17.2865 17.5938 16.9062 17.5938Z",
    fill: "#525E70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/Layer.667f28c20a420ae8a4da8b3e759ca322.svg";
export { ForwardRef as ReactComponent };